import { setLogoImage, setSignUpStep } from '../../../../store/signUp/slice';
import { selectLogoImage } from '../../../../store/signUp/selectors';
import { useDispatch, useSelector } from '../../../../store/store';
import MotionWrapper from '../../../../layouts/MotionWrapper';
import { TypographyLogo } from '../../../../assets/icons';
import UploadBox from '../../../../containers/UploadBox';
import styles from './styles.module.scss';

const fileTypes = [".JPEG", ".JPG", ".PNG"];

export default function UploadLogo() {
    const dispatch = useDispatch();
    const logoImage = useSelector(selectLogoImage);

    const onSaveImage = (imgUrl: string) => {
        dispatch(setLogoImage(imgUrl));
        dispatch(setSignUpStep('reviewInfo'));
    };

    const onSkip = () => {
        dispatch(setLogoImage(null));
        dispatch(setSignUpStep('reviewInfo'));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Sign Up</span>
            </div>
            <span className={styles.description}>
                Upload your company’s logo
            </span>
            <UploadBox
                aspect={1}
                fileTypes={fileTypes}
                onSave={onSaveImage}
                fileObjectURL={logoImage}
            />
            <span
                className={styles.skip}
                onClick={onSkip}
            >
                Skip this step for now
            </span>
        </MotionWrapper>
    );
};